import { FormattedDefaultTranscript } from '@goldcast/player-config/src/types/transcript-types';
import createStore from './store';

// TODO: @Hardik - To remove this store
export const fullTranscriptStore = createStore<FormattedDefaultTranscript>([]);
